import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/feedback/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);

    const showToast = useCallback((toastInfo) => {
        setToast(toastInfo);
    }, []);

    const hideToast = useCallback(() => {
        setToast(null);
    }, []);

    return (
        <ToastContext.Provider value={showToast}>
            {children}
            {toast && <Toast toastInfo={toast} onClose={hideToast} />}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);